import React, { useCallback, useEffect, useRef, useState } from 'react';
import { IconCloseEye, IconEye } from '@app/icons';
import { Button } from '../../../ui/button';

interface Props {
  onClickHideActive: (isActive: boolean) => void;
  isActive?: boolean;
}

function CardHideActiveButton(props: Props) {
  const { onClickHideActive, isActive: propsIsActive = false } = props;
  const [isActive, setIsActive] = useState<boolean>(propsIsActive);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const timeout = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    setIsActive(propsIsActive);
  }, [propsIsActive]);

  const onClickButton = useCallback(
    async (e?: React.MouseEvent) => {
      if (e) e.stopPropagation();
      if (isLoading) return;

      const newActiveState = !isActive;
      setIsActive(newActiveState);
      setIsLoading(true);

      if (timeout.current) {
        clearTimeout(timeout.current);
      }

      try {
        await onClickHideActive(newActiveState);
      } catch (error) {
        setIsActive(isActive);
        console.error('Failed to update tender status:', error);
      } finally {
        setIsLoading(false);
      }
    },
    [isActive, onClickHideActive, isLoading]
  );

  return (
    <Button
      variant={isActive ? 'default' : 'outline'}
      size="icon"
      onClick={onClickButton}
      disabled={isLoading}
      className="h-10 w-10"
    >
      {isActive ? <IconEye /> : <IconCloseEye />}
    </Button>
  );
}

export default CardHideActiveButton;
